import { useWishlistPage } from './useWishlistPage';
import { WishlistHeader } from './sections/WishlistHeader';
import { WishlistGrid } from './sections/WishlistGrid';
import { WishlistPagination } from './sections/WishlistPagination';

export function WishlistPage() {
  const {
    filter,
    setPage,
    billboards,
    totalPages,
    totalItems,
    rangeLabel,
    isPending,
  } = useWishlistPage();

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-5">
      <WishlistHeader isPending={isPending} totalItems={totalItems} />

      <WishlistGrid isPending={isPending} items={billboards} />

      {!isPending && totalItems > 0 ? (
        <WishlistPagination
          page={filter.page}
          totalPages={totalPages}
          isPending={isPending}
          rangeLabel={rangeLabel}
          onPageChange={setPage}
        />
      ) : null}
    </div>
  );
}

export default WishlistPage;
